<div class="audit-list-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <div class="heading-wrapper">
    <h4>{{ 'pages.audit.title' | translate }}</h4>
    <div class="actions">
      <button
        class="secondary download-excel"
        [disabled]="isExcelDownloading"
        [ngClass]="{ downloading: isExcelDownloading }"
        (click)="downloadExcel()">
        @if (!isExcelDownloading) {
          <img src="assets/images/download-excel.svg" alt="download-excel.svg" />
          {{ 'pages.user.saveExcel' | translate }}
        } @else {
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
        }
      </button>
    </div>
  </div>
  <app-table
    [endpoint]="auditEndpoint"
    [columns]="columns"
    [withSearch]="false"
    [linkRow]="false"
    sortBy="createdOn"
    sortDirection="desc"
    viewEntryPath="" />
</div>
